/**
 * Cost matrix view used in icon navigation.
 */
import { Box, Typography } from "@mui/material";
import { useConfigurations } from "../../../../context/ConfigurationsContext/ConfigurationsContext";

type CostsProps = {
  paymentMode?: boolean;
};

const Costs = ({ paymentMode = false }: CostsProps) => {
  const { exchangeRates, IndividualPrice } = useConfigurations();

  const convertFromMXN = (passengers: number, exchangeRate: number | null) => {
    if (!exchangeRate || IndividualPrice <= 0) return "0.00";
    return (passengers * IndividualPrice * exchangeRate).toFixed(2);
  };

  const rows = Array.from({ length: 10 }, (_, index) => {
    const passengers = index + 1;
    return {
      passengers,
      mxn: convertFromMXN(passengers, 1),
      usd: convertFromMXN(passengers, exchangeRates.USD),
      eur: convertFromMXN(passengers, exchangeRates.EUR),
      gbp: convertFromMXN(passengers, exchangeRates.GBP),
      jpy: convertFromMXN(passengers, exchangeRates.JPY),
    };
  });

  return (
    <Box
      sx={{
        ...(paymentMode
          ? {
              bgcolor: "#F6F6F6",
              height: "100%",
              minHeight: "100%",
              overflow: "auto",
              overflowX: "hidden",
              position: "relative",
              width: "100%",
              maxWidth: "100%",
              zIndex: 1,
            }
          : {
              bgcolor: "white",
              height: "100vh",
              left: 0,
              overflow: "auto",
              overflowX: "hidden",
              position: "fixed",
              top: 0,
              width: "100%",
              zIndex: 10,
            }),
      }}
    >
      <Box
        sx={{
          boxSizing: "border-box",
          margin: "0 auto",
          maxWidth: "651px",
          pt: { xs: "96px", md: "78px" },
          px: { xs: 2, md: "3px" },
          width: "100%",
        }}
      >
        <Box
          sx={{
            alignItems: "center",
            color: "#761542",
            display: "grid",
            gap: { xs: "4px", md: "15px" },
            gridTemplateColumns: { xs: "24px repeat(5, minmax(0, 1fr))", md: "126px repeat(5, 90px)" },
          }}
        >
          <Typography
            sx={{
              fontFamily: "Candara",
              fontSize: { xs: "14px", md: "18px" },
              fontWeight: 700,
              lineHeight: { xs: "16px", md: "20px" },
              textAlign: "center",
            }}
          >
            #
          </Typography>
          <Typography sx={{ color: "#761542", fontFamily: "Candara", fontSize: { xs: "13px", md: "18px" }, fontWeight: 700, lineHeight: { xs: "16px", md: "20px" }, textAlign: "right" }}>MXN</Typography>
          <Typography sx={{ color: "#761542", fontFamily: "Candara", fontSize: { xs: "13px", md: "18px" }, fontWeight: 700, lineHeight: { xs: "16px", md: "20px" }, textAlign: "right" }}>USD</Typography>
          <Typography sx={{ color: "#761542", fontFamily: "Candara", fontSize: { xs: "13px", md: "18px" }, fontWeight: 700, lineHeight: { xs: "16px", md: "20px" }, textAlign: "right" }}>EUR</Typography>
          <Typography sx={{ color: "#761542", fontFamily: "Candara", fontSize: { xs: "13px", md: "18px" }, fontWeight: 700, lineHeight: { xs: "16px", md: "20px" }, textAlign: "right" }}>GBP</Typography>
          <Typography sx={{ color: "#761542", fontFamily: "Candara", fontSize: { xs: "13px", md: "18px" }, fontWeight: 700, lineHeight: { xs: "16px", md: "20px" }, textAlign: "right" }}>JPY</Typography>
        </Box>

        <Box sx={{ borderTop: "2px solid #00596A", mt: "14px", width: "100%" }} />

        <Box sx={{ display: "flex", flexDirection: "column", gap: "10px", mt: "15px" }}>
          {rows.map((row) => (
            <Box
              key={row.passengers}
              sx={{
                alignItems: "center",
                color: "#232323",
                display: "grid",
                gap: { xs: "4px", md: "15px" },
                gridTemplateColumns: { xs: "24px repeat(5, minmax(0, 1fr))", md: "126px repeat(5, 90px)" },
              }}
            >
              <Typography sx={{ fontFamily: "Candara", fontSize: { xs: "16px", md: "16px" }, fontWeight: 400, lineHeight: "20px", textAlign: "center" }}>
                {row.passengers}
              </Typography>
              <Typography sx={{ color: "#232323", fontFamily: "Candara", fontSize: { xs: "12px", md: "16px" }, fontWeight: 400, lineHeight: { xs: "18px", md: "20px" }, textAlign: "right", fontVariantNumeric: "tabular-nums" }}>{row.mxn}</Typography>
              <Typography sx={{ color: "#232323", fontFamily: "Candara", fontSize: { xs: "12px", md: "16px" }, fontWeight: 400, lineHeight: { xs: "18px", md: "20px" }, textAlign: "right", fontVariantNumeric: "tabular-nums" }}>{row.usd}</Typography>
              <Typography sx={{ color: "#232323", fontFamily: "Candara", fontSize: { xs: "12px", md: "16px" }, fontWeight: 400, lineHeight: { xs: "18px", md: "20px" }, textAlign: "right", fontVariantNumeric: "tabular-nums" }}>{row.eur}</Typography>
              <Typography sx={{ color: "#232323", fontFamily: "Candara", fontSize: { xs: "12px", md: "16px" }, fontWeight: 400, lineHeight: { xs: "18px", md: "20px" }, textAlign: "right", fontVariantNumeric: "tabular-nums" }}>{row.gbp}</Typography>
              <Typography sx={{ color: "#232323", fontFamily: "Candara", fontSize: { xs: "12px", md: "16px" }, fontWeight: 400, lineHeight: { xs: "18px", md: "20px" }, textAlign: "right", fontVariantNumeric: "tabular-nums" }}>{row.jpy}</Typography>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default Costs;
